// extracted by mini-css-extract-plugin
export default {"ctnMare":"Contact_ctnMare__vQahf","titluMare":"Contact_titluMare__mvBuJ","ctnGrid":"Contact_ctnGrid__u2wNB"};